module.exports = __webpack_public_path__ + "static/media/021-cook-islands.a06daf1e.svg";